module.exports = __webpack_public_path__ + "static/media/CoreSans-65Bold.14abc963.woff";